import { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import enStrings from "../services/strings.en.json";
import enDIYStrings from "../services/strings.en.diy.json";
import esDIYStrings from "../services/strings.es.diy.json";

const LanguageContext = createContext({ lang: "en", strings: enStrings });

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (ctx === undefined) {
    throw new Error("useLanguage must be inside a LanguageContext provider.");
  }

  return ctx;
}

// eslint-disable-next-line react/prop-types
/**
 * @component
 * @param {Object} args
 * @param {React.ReactNode} args.children
 */
export function LanguageProvider({ children }) {
  const { lang: selectedLang } = useSelector((state) => state.settings);
  const [params] = useSearchParams();
  const isDIY = params.get("diy");
  let lang = "en";
  if (selectedLang === "English") {
    lang = "en";
  } else if (selectedLang === "Español") {
    lang = "es";
  }

  document.documentElement.lang = lang;

  let strings = enStrings;
  if (lang === "en" && isDIY) {
    strings = enDIYStrings;
  } else if (lang === "en" && !isDIY) {
    strings = enStrings;
  } else if (lang === "es") {
    strings = esDIYStrings;
  }

  const value = useMemo(
    () => ({
      strings,
      lang,
    }),
    [lang]
  );

  return (
    <LanguageContext.Provider
      // @ts-ignore
      value={value}
    >
      {children}
    </LanguageContext.Provider>
  );
}

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
